<template>
  <div class="otherPay-success" :class="{ inApp: $root.$data.isApp }">
    <common-title titleName="代付款" :goHome="true" :zIndex="1000"></common-title>
    <div style="width: 100%;text-align: center;">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pay_success.png" alt="" class="payError">
    </div>
    <p class="payError-tip">订单支付成功!</p>
    <div @click="goHone" class="btn-back">返回首页</div>
  </div>
</template>

<script>
export default {
  methods: {
    goHone() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style lang="scss" scoped>
.otherPay-success {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 240px;
  background: #f9f9f9;
  user-select: none;

  .payError {
    display: inline-block;
    height: 109px;
    width: 109px;
    margin: 330px 0 29px;

    &-tip {
      margin: 0 auto;
      height: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 29px;
      color: #333333;
      line-height: 40px;
      text-align: center;
      font-style: normal;
    }
  }

  .btn-back {
    width: 283px;
    height: 80px;
    background: #FF7F41;
    border-radius: 41px;
    margin: 80px auto;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 29px;
    color: #FFFFFF;
    line-height: 80px;
    text-align: center;
    font-style: normal;
  }
}

.inApp {
  padding-top: 0;
}
</style>
